"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzModal = void 0;
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const className_1 = require("../../utils/className");
const ButtonV2_1 = require("../ButtonV2");
exports.VbzModal = (_a) => {
    var { id, idBtnClose = 'btn_close', children = '', className = '', isOpen = true, role = 'dialog', defaultHeader = true, type = 'right', hideHeader = false, backdrop = true, initialFocus = 'div', hasScroll, title, desktopSize = 'small', modalColor = 'light', mobileSize, backButton = false, closedButton = true, contentClassName, dataTestId, onEnter, toggle, onOpened, onClosed, onExit } = _a, props = __rest(_a, ["id", "idBtnClose", "children", "className", "isOpen", "role", "defaultHeader", "type", "hideHeader", "backdrop", "initialFocus", "hasScroll", "title", "desktopSize", "modalColor", "mobileSize", "backButton", "closedButton", "contentClassName", "dataTestId", "onEnter", "toggle", "onOpened", "onClosed", "onExit"]);
    const modal = react_1.useRef(null);
    const [open, setOpen] = react_1.useState(isOpen);
    const [hidden, setHidden] = react_1.useState(isOpen);
    const [isLoading, setIsLoading] = react_1.useState(true);
    const [isAnimation, setIsAnimation] = react_1.useState(false);
    const [modalStyle, setModalStyle] = react_1.useState({});
    const [isTextScrolled, setIsTextScrolled] = react_1.useState(false);
    const [progressBarStyle, setProgressBarStyle] = react_1.useState();
    const [ariaValueNow, setAriaValueNow] = react_1.useState(0);
    const [scrollPosition, setScrollPosition] = react_1.useState({ x: 0, y: 0 });
    function animationDebounce() {
        setIsAnimation(true);
        setTimeout(() => {
            setIsAnimation(false);
        }, 1000);
    }
    const resetProperties = () => {
        setProgressBarStyle(() => {
            return {
                width: '0%',
            };
        });
        setIsTextScrolled(false);
    };
    const handleIsOpen = (e) => {
        if (isAnimation)
            return e;
        animationDebounce();
        if (hasScroll)
            resetProperties();
        if (toggle)
            return toggle(e);
        return setOpen((prev) => !prev);
    };
    const handleScroll = (e) => {
        const element = e.currentTarget;
        const scrolled = element.scrollTop;
        const scrollView = element.clientHeight;
        const contentScrollHeight = element.scrollHeight;
        const utilHeight = contentScrollHeight - scrollView;
        const percentScroll = (scrolled / utilHeight) * 100;
        const isScrolled = percentScroll > 1;
        setIsTextScrolled(isScrolled);
        setProgressBarStyle({
            width: `${percentScroll}%`,
        });
        setAriaValueNow(percentScroll);
    };
    react_1.useEffect(() => {
        var _a, _b;
        const handleClickOutside = (event) => {
            if (!open || !event.target.classList.contains('backdrop'))
                return;
            if (hasScroll)
                resetProperties();
            if (!isAnimation) {
                toggle === null || toggle === void 0 ? void 0 : toggle(event);
                animationDebounce();
            }
        };
        (_b = (_a = modal.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.addEventListener('mousedown', handleClickOutside);
        return () => {
            var _a, _b;
            (_b = (_a = modal.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.removeEventListener('mousedown', handleClickOutside, false);
        };
    }, [modal, open, toggle, isAnimation]);
    react_1.useEffect(() => {
        var _a, _b;
        setIsLoading(false);
        animationDebounce();
        if (isOpen) {
            const bodyElement = document.querySelector('body');
            bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.setAttribute('class', 'unscrollable');
            setHidden(!isOpen);
            setTimeout(() => {
                setOpen(isOpen);
            }, 10);
            setScrollPosition({ y: window.pageYOffset, x: window.pageXOffset });
            onOpened === null || onOpened === void 0 ? void 0 : onOpened();
            onEnter === null || onEnter === void 0 ? void 0 : onEnter();
        }
        else {
            if (document.querySelectorAll('.modal.show').length <= 1) {
                const currentClass = (_a = document
                    .querySelector('body')) === null || _a === void 0 ? void 0 : _a.getAttribute('class');
                (_b = document
                    .querySelector('body')) === null || _b === void 0 ? void 0 : _b.setAttribute('class', currentClass ? currentClass.replace('unscrollable', '') : '');
                window.scroll(scrollPosition.x, scrollPosition.y);
            }
            setOpen(isOpen);
        }
    }, [isOpen, isLoading]);
    react_1.useEffect(() => {
        if (type === 'full' && !isLoading) {
            setTimeout(() => {
                setHidden(!open);
            }, 1010);
        }
        else if (!isLoading) {
            setTimeout(() => {
                setHidden(!open);
            }, 510);
        }
        else {
            setHidden(!open);
        }
    }, [type, open, isLoading]);
    react_1.useEffect(() => {
        if (isOpen === false && open === true) {
            onClosed === null || onClosed === void 0 ? void 0 : onClosed();
            onExit === null || onExit === void 0 ? void 0 : onExit();
            setTimeout(() => {
                setModalStyle({
                    zIndex: -1,
                    display: type === 'full' || !type ? 'none' : 'block',
                });
            }, type === 'full' ? 950 : 450);
        }
    }, [isOpen]);
    react_1.useEffect(() => {
        if (isOpen) {
            if (!open) {
                setModalStyle({
                    zIndex: -1,
                    display: 'block',
                });
            }
            else {
                setModalStyle({
                    zIndex: 1050,
                    display: 'block',
                });
            }
        }
    }, [open]);
    react_1.useEffect(() => {
        if (!isOpen) {
            if (!open && type === 'full') {
                setModalStyle({
                    display: 'none',
                });
            }
            else if (!open) {
                setModalStyle({
                    zIndex: -1,
                    display: 'block',
                });
            }
            else {
                setModalStyle({
                    zIndex: 1050,
                    display: 'block',
                });
            }
        }
    }, []);
    const ModalButtons = react_1.default.useCallback(({ divClassName, icon, customId }) => {
        return (react_1.default.createElement("div", { className: divClassName },
            react_1.default.createElement(ButtonV2_1.Button, { icon: react_1.default.createElement("i", { className: "material-icons" }, icon), fill: false, type: "pill", variant: "circle", onClick: handleIsOpen, theme: modalColor !== 'light' ? 'dark' : 'light', id: customId })));
    }, [modalColor, handleIsOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null, !hidden && (react_1.default.createElement(focus_trap_react_1.default, { active: open, focusTrapOptions: {
            allowOutsideClick: true,
            delayInitialFocus: true,
            fallbackFocus: 'div',
            initialFocus,
        } },
        react_1.default.createElement("div", { className: className_1.mapToCssModules([
                className,
                'modal',
                'fade',
                open ? 'show' : undefined,
                desktopSize ? 'redesign' : '',
                backdrop ? 'backdrop' : '',
                'trap',
                hidden ? 'hidden' : '',
            ]), id: id, tabIndex: -1, role: role, style: modalStyle, "data-testid": dataTestId },
            react_1.default.createElement("div", Object.assign({ ref: modal, className: className_1.mapToCssModules([
                    'modal-dialog',
                    type,
                    desktopSize,
                    mobileSize,
                ]) }, props),
                react_1.default.createElement("div", { className: className_1.mapToCssModules([
                        'modal-content',
                        modalColor,
                        contentClassName,
                    ]) },
                    hasScroll && (react_1.default.createElement("div", { className: "vbz-switch" },
                        react_1.default.createElement("div", { className: "progress" },
                            react_1.default.createElement("div", { className: "progress-bar", "aria-valuenow": ariaValueNow, "aria-valuemin": 0, "aria-valuemax": 100, style: progressBarStyle })))),
                    defaultHeader && (react_1.default.createElement("div", { className: className_1.mapToCssModules([
                            `modal-header${!hideHeader ? '' : ' hidden'}`,
                            hasScroll ? 'scroll-header scroll-shadow' : '',
                            isTextScrolled
                                ? 'scroll-header__collapse scroll-shadow__show'
                                : '',
                        ]) },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            mobileSize === 'drawer' && (react_1.default.createElement(ModalButtons, { divClassName: "new-button-drawer", icon: "expand_more" })),
                            closedButton && (react_1.default.createElement(ModalButtons, { divClassName: "close-button", icon: "\uE5CD", customId: idBtnClose })),
                            title && (react_1.default.createElement("p", { className: className_1.mapToCssModules([
                                    'modal-text-header',
                                    hasScroll ? 'header-text' : '',
                                    isTextScrolled ? 'header-text__show' : '',
                                    backButton ? 'modal-text-header__margin' : '',
                                ]) }, title)),
                            backButton && (react_1.default.createElement(ModalButtons, { icon: "chevron_left", divClassName: "back-button" }))))),
                    hasScroll ? (react_1.default.createElement("div", { className: "modal-body", tabIndex: 0, onScroll: handleScroll }, children)) : (children))))))));
};
//# sourceMappingURL=index.js.map